var lib_core           = require("lib-core");
var LoadingView         = require("./loadingView.js");

var LoadingController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(LoadingController, lib_core.Controller);

LoadingController.prototype.createView = function () {
    return new LoadingView(this.editorHolder, this.configuration);
};

LoadingController.prototype.beforeLoad = function() {
    this.editorHolder = this.root.editorHolder;
    lib_core.Controller.prototype.beforeLoad.call(this);
};

LoadingController.prototype.afterLoad = function () {
    lib_core.Controller.prototype.afterLoad.call(this);
    this.getView().hide();
};

module.exports = LoadingController;
